module.exports = __webpack_public_path__ + "img/ORIGINAL WAYFARER CLASSIC.ba8cf46b.jpg";